import { render, staticRenderFns } from "./fcwpSidebarCard.vue?vue&type=template&id=56f35227&"
import script from "./fcwpSidebarCard.vue?vue&type=script&lang=js&"
export * from "./fcwpSidebarCard.vue?vue&type=script&lang=js&"
import style0 from "./fcwpSidebarCard.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports